import React, { useContext, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router'
import { Link } from 'react-router-dom'
import $ from 'jquery'


import PageUrlGuid from '../../component/pageUrlGuid'
import Seperator from '../../component/seperator'
import { totalOff, webinar, webinarOff } from '../../service/webinarsService'
import { errorMessage, successMessage } from '../../utils/toastMessage'


//third party
import { useSelector, useDispatch } from 'react-redux'
import Countdown from 'react-countdown';




const RegisterWebinar = () => {
    const user = useSelector((state) => state.user)


    const slug = useParams().slug
    const navigate = useNavigate()

    const [getItem, setItem] = useState({})
    const [getOff, setOff] = useState(0)
    const [getTotalOff, setTotalOff] = useState(0)
    const [getOffCode, setOffCode] = useState("userDontEnterCode")

    const handleGetItem = async () => {
        try {
            const { status, data } = await webinar(slug);
            if (status === 200) {
                setItem(data.webinar)
            }
        }
        catch (ex) {
            navigate("/notFound")
        }
    }
    const handleValidateOffCode = async () => {
        var code = document.querySelector(".off-input").value
        if (code == "") {
            errorMessage("کد تخفیف را وارد کنید")
        }
        else {
            try {
                const { status, data } = await webinarOff(slug, code);
                if (status === 200) {
                    successMessage("کد تایید شد")
                    setOff(parseInt(data.message))
                    setOffCode(code)
                }
                if (status == 404) {
                    errorMessage("کد نا معتبر است")

                }

            }
            catch (ex) {
                if (ex.response.status == 404) {
                    errorMessage("کد نا معتبر است")

                }
            }
        }
    }
    const handleGetTotalCode = async () => {
        try {
            const { status, data } = await totalOff();
            if (status === 200) {
                if (Date.now() <= (data.totalOff.date * 1000 + data.totalOff.time * 60 * 60 * 1000)) {
                    setTotalOff(data.totalOff)
                }
            }
        }
        catch (ex) {
        }
    }



    useEffect(() => {
        handleGetItem()
        handleGetTotalCode()
    }, [])
    useEffect(() => {

        var colors = new Array(
            [62, 35, 255],
            [60, 255, 60],
            [255, 35, 98],
            [45, 175, 230],
            [255, 0, 255],
            [255, 128, 0]);

        var step = 0;
        //color table indices for: 
        // current color left
        // next color left
        // current color right
        // next color right
        var colorIndices = [0, 1, 2, 3];

        //transition speed
        var gradientSpeed = 0.002;

        function updateGradient() {

            if ($ === undefined) return;

            var c0_0 = colors[colorIndices[0]];
            var c0_1 = colors[colorIndices[1]];
            var c1_0 = colors[colorIndices[2]];
            var c1_1 = colors[colorIndices[3]];

            var istep = 1 - step;
            var r1 = Math.round(istep * c0_0[0] + step * c0_1[0]);
            var g1 = Math.round(istep * c0_0[1] + step * c0_1[1]);
            var b1 = Math.round(istep * c0_0[2] + step * c0_1[2]);
            var color1 = "rgb(" + r1 + "," + g1 + "," + b1 + ")";

            var r2 = Math.round(istep * c1_0[0] + step * c1_1[0]);
            var g2 = Math.round(istep * c1_0[1] + step * c1_1[1]);
            var b2 = Math.round(istep * c1_0[2] + step * c1_1[2]);
            var color2 = "rgb(" + r2 + "," + g2 + "," + b2 + ")";

            $('#gradient').css({
                background: "-webkit-gradient(linear, left top, right top, from(" + color1 + "), to(" + color2 + "))"
            }).css({
                background: "-moz-linear-gradient(left, " + color1 + " 0%, " + color2 + " 100%)"
            });

            step += gradientSpeed;
            if (step >= 1) {
                step %= 1;
                colorIndices[0] = colorIndices[1];
                colorIndices[2] = colorIndices[3];

                //pick two new target color indices
                //do not pick the same as the current one
                colorIndices[1] = (colorIndices[1] + Math.floor(1 + Math.random() * (colors.length - 1))) % colors.length;
                colorIndices[3] = (colorIndices[3] + Math.floor(1 + Math.random() * (colors.length - 1))) % colors.length;

            }
        }

        setInterval(updateGradient, 10);
    }, [])
    return (
        <>
            <PageUrlGuid>
                <Link to={"/"}>
                    صفحه اصلی
                </Link>
                <Seperator amount={5} />
                /
                <Seperator amount={5} />
                <h2>
                    ثبت نام در وبینار
                </h2>
                <Seperator amount={5} />
                /
                <Seperator amount={5} />
                <h1>
                    {getItem.title}
                </h1>
            </PageUrlGuid>
            {getTotalOff == 0 ? null : (

                <div id="gradient" >
                    <div>
                        <span>{getTotalOff.name}</span>
                        <span style={{ color: "green" }}>

                            <Countdown date={getTotalOff.date * 1000 + getTotalOff.time * 60 * 60 * 1000} />
                        </span>
                    </div>
                </div>
            )}

            <div className='buy'>
                <div className='infos'>
                    <div className='info'>
                        <span>  موضوع   :</span>
                        <span>{getItem.title}</span>
                    </div>
                    <div className='info'>
                        <span>  قیمت   :</span>
                        {getTotalOff == 0 ? (
                            <span style={{ color: "green" }}> {getItem.priceForRegister == undefined ? null : getItem.priceForRegister.toLocaleString("en-US")} تومان</span>

                        ) : (
                            <>
                                <span style={{ color: "green" }}> {getItem.priceForRegister == undefined ? null : (Math.ceil((getItem.priceForRegister - (getItem.priceForRegister * getTotalOff.amount / 100)) / 1000) * 1000).toLocaleString("en-US")} تومان</span>
                                <del style={{ color: "red" }}> {getItem.priceForRegister == undefined ? null : getItem.priceForRegister.toLocaleString("en-US")} تومان</del>
                            </>
                        )}

                    </div>
                    <div className='info'>
                        <span>   کد تخفیف  :</span>
                        <input type="text" className='off-input' />
                        {getOff == 0 ? (
                            <button onClick={handleValidateOffCode}>معتبر سازی کد</button>
                        ) : (
                            // <button>تخفیف {getOff==undefined ? null : getOff.toLocaleString("en-US") }   تومانی تایید شد</button>
                            <button>تخفیف  {getOff.toLocaleString("en-US")} تومانی تایید شد  </button>
                        )}

                    </div>
                </div>
                <div className='buy-final'>
                    <div className='final'>
                        <span>قابل پرداخت :</span>
                        {getTotalOff == 0 ? (
                            <span>{` ${getItem.priceForRegister == undefined ? null : (getItem.priceForRegister  - getOff).toLocaleString("en-US")} `} تومان</span>

                        ) : (
                            <span>{` ${getItem.priceForRegister == undefined ? null : (Math.ceil((getItem.priceForRegister - (getItem.priceForRegister * getTotalOff.amount / 100)) / 1000) * 1000 - getOff).toLocaleString("en-US")} `} تومان</span>
                        )}
                    </div>
                    <br />
                    <a href={`https://www.newwebinar.ir/api/registerWebinar/${slug}/${getOffCode}/${user.value.username}`}>
                        <span>پرداخت</span>
                    </a>
                </div>
            </div>
        </>
    )
}

export default RegisterWebinar